import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  Button,
  Popover,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import axios from "axios";
import { getETFSearch, getETFSearchTheme } from "./network_requests";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useParams } from "react-router";
import Header from "../../constants/Header";
import { useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";

const EtfSearchTable = ({ t }) => {
  const [rows, setRows] = useState(null);
  const [data, setData] = useState(null);
  const [load, setLoad] = useState(false);
  const { query, symbol } = useParams();
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  useEffect(async () => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    (async () => {
      if (query) {
        setLoad(true);
        const searchData = await getETFSearch(query, symbol);
        setRows(searchData ? searchData?.table : null);
        setData(searchData ? searchData : null);
        setLoad(false);
      }
    })();

    return () => {
      source.cancel();
    };
  }, [query]);

  return (
    <>
      <TableContainer component={Paper} style={{ minHeight: "80vh" }}>
        <Table size="small" style={{ tableLayout: "fixed" }}>
          <div
            style={{
              position: isDesktopOrLaptop ? "absolute" : "",
              width: "100%",
              left: 0,
              top: 0,
            }}
          >
            <Header placeHolder={t("search_placeholder")} t={t} />
          </div>
          {isDesktopOrLaptop ? <div style={{ height: "153px" }} /> : null}
          <Typography
            variant="h6"
            style={{
              textAlign: "center",
              fontFamily: "Overpass",
              fontWeight: "bold",
              marginTop: "15px",
            }}
          >
            {data?.Title}
          </Typography>
          {load ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "20px",
                paddingBottom: "20px",
              }}
            >
              <CircularProgress />
            </div>
          ) : rows ? (
            <TableBody>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    height: 50 * (rows?.values?.length + 1),
                    maxHeight: "90vh",
                    overflow: "scroll",
                    width: 860,
                  }}
                  className="ag-theme-alpine invisible-scrollbar"
                >
                  <AgGridReact
                    defaultColDef={{
                      sortable: true,
                      filter: true,
                    }}
                    rowData={rows ? rows?.values : []}
                    rowSelection={"single"}
                  >
                    {rows?.columns.map((value) => {
                      return (
                        <AgGridColumn
                          field={value}
                          filter="agTextColumnFilter"
                          width={140}
                        />
                      );
                    })}
                  </AgGridReact>
                </div>
              </div>
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  fontFamily: "Overpass",
                  fontWeight: "bold",
                }}
              >
                Sum Assets: {data?.sum_assets}
              </Typography>
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  fontFamily: "Overpass",
                  fontWeight: "bold",
                }}
              >
                Sum Score: {data?.sum_Score_mul_assets}
              </Typography>
              <Typography
                variant="h6"
                style={{
                  textAlign: "center",
                  fontFamily: "Overpass",
                  fontWeight: "bold",
                }}
              >
                Weighted Average: {data?.weighted_average}
              </Typography>
            </TableBody>
          ) : null}
        </Table>
      </TableContainer>
    </>
  );
};

export default withNamespaces()(EtfSearchTable);
